module.exports = __webpack_public_path__ + "img/footer-background.dc29407b.svg";